import React from 'react';
import { Panel, Row, Col } from 'react-bootstrap';

import { BasicValidation } from '../validation/basicValidation';
import { statusTypes } from "../config/constants";

const BasicInfoSummary = (props) => {
  const withoutValidation = props.withoutValidation;
  const validationStatus = new BasicValidation().getValidationStatus(props);
  const showAddress1 = !!props.address.address1;
  const showAddress2 = !!props.address.address2;
  return(
    <Panel className="basic-info-panel" header="Basic Information" bsStyle={withoutValidation ? statusTypes.INFO : validationStatus.section.status}>
      <Row>
        <Col md={6}>
          <dl className="dl-horizontal">
            <dt>Delta Id</dt>
            <dd>{props.deltaId}</dd>
            <dt>Name</dt>
            <dd>{props.name.displayName}</dd>
            <dt>Student Email</dt>
            <dd>{props.email}</dd>
            <dt>Gender</dt>
            <dd>{props.gender}</dd>
            <dt>DOB</dt>
            <dd>{props.dateOfBirth}</dd>
          </dl>
        </Col>
        <Col md={6}>
          <dl className="dl-horizontal">
            <dt>Primary Address</dt>
            <dd>
              {showAddress1 &&
                <span>{props.address.address1}<br/></span>
              }
              {showAddress2 &&
                <span>{props.address.address2}<br/></span>
              }
              {props.address.city}, {props.address.state} {props.address.zip}
            </dd>
            <dt>Contact Phone Number</dt>
            <dd>{props.phones.filter(phone => phone.type === "H")[0].number}</dd>
            <dt>Personal Email</dt>
            <dd>{props.personalEmail}</dd>
          </dl>
        </Col>
      </Row>
    </Panel>
  );
};

export default BasicInfoSummary;